import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import store from "redux/store";
import {
  GET_ADDVEHICLE_FAILED,
  GET_ADDVEHICLE_REQUESTED,
  GET_ADDVEHICLE_SUCCESS,
  GET_DELETEVEHICLE_FAILED,
  GET_DELETEVEHICLE_REQUESTED,
  GET_DELETEVEHICLE_SUCCESS,
  GET_UPDATEVEHICLE_FAILED,
  GET_UPDATEVEHICLE_REQUESTED,
  GET_UPDATEVEHICLE_SUCCESS,
  GET_VEHICLE_FAILED,
  GET_VEHICLE_REQUESTED,
  GET_VEHICLE_SUCCESS,
  GET_MATRIXVEHICLE_FAILED,
  GET_MATRIXVEHICLE_REQUESTED,
  GET_MATRIXVEHICLE_SUCCESS,
  GET_MOREVEHICLE_FAILED,
  GET_MOREVEHICLE_REQUESTED,
  GET_MOREVEHICLE_SUCCESS,
} from "resources/actionTypes";
import {
  addVehicleApi,
  deleteVehicleApi,
  matrixVehicleApi,
  moreVehicleApi,
  updateVehicleApi,
  vehicleApi,
} from "services/VehicleService";
import { getVehicle } from "redux/actions/UserVehicle";
import { getOnBoardCompliance } from "redux/actions/UserCompliance";
import { getDriver } from "redux/actions/UserDriver";

function* fetchVehicle(action) {
  try {
    const payload = action.payload || {};
    const userVehicle = yield call(vehicleApi, payload);
    yield put({
      type: GET_VEHICLE_SUCCESS,
      userVehicle: userVehicle,
    });
  } catch (e) {
    yield put({
      type: GET_VEHICLE_FAILED,
      message: e.message
    })
    toast.error(e.message || 'Get Vehicle Failed')
  }
}

export function* vehicleSaga() {
  yield takeEvery(GET_VEHICLE_REQUESTED, fetchVehicle);
}

function* fetchAddVehicle(action) {
  const payload = action.payload || {};
  const userAddVehicle = yield call(addVehicleApi, payload.userAddVehicle);
  if (userAddVehicle.success) {
    yield put({ type: GET_ADDVEHICLE_SUCCESS, userAddVehicle: userAddVehicle });
    localStorage.setItem("vehicleId", userAddVehicle?.data[0]?.vehicleId);
    toast.success(userAddVehicle.message);
    store.dispatch(
      getVehicle({
        id: payload?.userAddVehicle?.get("id"),
        status: "",
        type: payload?.userAddVehicle?.get("type"),
        page: "",
        pageSize: "",
      })
    );
    store.dispatch(
      getOnBoardCompliance({
        vehicleId: userAddVehicle?.data[0]?.vehicleId,
        type: "vehicleRegistration",
      })
    );
    store.dispatch(
      getDriver({ driverId: payload?.userAddVehicle?.get("driverId") })
    );
  } else {
    yield put({ type: GET_ADDVEHICLE_FAILED, message: userAddVehicle.message });
      toast.error(userAddVehicle.message || 'Add Vehicle failed');
  }
}

export function* addVehicleSaga() {
  yield takeEvery(GET_ADDVEHICLE_REQUESTED, fetchAddVehicle);
}

function* fetchUpdateVehicle(action) {
  const payload = action.payload || {};
  const userUpdateVehicle = yield call(
    updateVehicleApi,
    payload.userUpdateVehicle
  );
  if (userUpdateVehicle.success) {
    yield put({
      type: GET_UPDATEVEHICLE_SUCCESS,
      userUpdateVehicle: userUpdateVehicle,
    });
    toast.success(userUpdateVehicle.message);
    if (payload?.userUpdateVehicle?.parentId) {
      store.dispatch(
        getVehicle({
          id: payload?.userUpdateVehicle?.parentId,
          type: payload?.userUpdateVehicle?.type,
          status: '',
          page: payload?.userUpdateVehicle?.page,
          search: payload?.userUpdateVehicle?.search,
          pageSize: payload?.userUpdateVehicle?.pageSize,
          date: '',
        })
      );
    }
    else if (payload?.userUpdateVehicle?.cityId) {
      store.dispatch(
        getVehicle({ id: payload?.userUpdateVehicle?.cityId, type: "vendor",
        page: payload?.userUpdateVehicle?.page,
        search: payload?.userUpdateVehicle?.search,
        pageSize: payload?.userUpdateVehicle?.pageSize,
        status: payload?.userUpdateVehicle?.status})
      );
    } else if (payload?.userUpdateVehicle?.subVendorId) {
      store.dispatch(
        getVehicle({
          subVendorId: payload?.userUpdateVehicle?.subVendorId,
          type: "subVendor",
          page: payload?.userUpdateVehicle?.page,
          search: payload?.userUpdateVehicle?.search,
          pageSize: payload?.userUpdateVehicle?.pageSize,
          status: payload?.userUpdateVehicle?.status
        })
      );
    } else {
      store.dispatch(
        getVehicle({ vehicleId: payload.userUpdateVehicle?.get("id") })
      );
    }
  } else {
    yield put({
      type: GET_UPDATEVEHICLE_FAILED,
      message: userUpdateVehicle.message,
    });
      toast.error(userUpdateVehicle.message || 'Update Vehicle failed');
  }
}

export function* updateVehicleSaga() {
  yield takeEvery(GET_UPDATEVEHICLE_REQUESTED, fetchUpdateVehicle);
}

function* fetchDeleteVehicle(action) {
  const payload = action.payload || {};
  const userDeleteVehicle = yield call(
    deleteVehicleApi,
    payload.userDeleteVehicle
  );
  if (userDeleteVehicle.success) {
    yield put({
      type: GET_DELETEVEHICLE_SUCCESS,
      userDeleteVehicle: userDeleteVehicle,
    });
    toast.success(userDeleteVehicle.message);
    // store.dispatch(
    //   getVehicle({ vehicleId: payload.userDeleteVehicle.vehicleId })
    // );
  } else {
    yield put({
      type: GET_DELETEVEHICLE_FAILED,
      message: userDeleteVehicle.message,
    });
      toast.error(userDeleteVehicle.message || 'Delete Vehicle failed');
  }
}

export function* deleteVehicleSaga() {
  yield takeEvery(GET_DELETEVEHICLE_REQUESTED, fetchDeleteVehicle);
}

function* fetchMatrixVehicle(action) {
  try {
    const payload = action.payload || {};
    const userMatrixVehicle = yield call(matrixVehicleApi, payload);
    yield put({
      type: GET_MATRIXVEHICLE_SUCCESS,
      userMatrixVehicle: userMatrixVehicle,
    });
  } catch (e) {
    yield put({
      type: GET_MATRIXVEHICLE_FAILED,
      message: e.message
    })
    toast.error(e.message || 'Get Matrix Vehicle Failed')
  }
}

export function* matrixVehicleSaga() {
  yield takeEvery(GET_MATRIXVEHICLE_REQUESTED, fetchMatrixVehicle);
}

function* fetchMoreVehicle(action) {
  try {
    const payload = action.payload || {};
    const userMoreVehicle = yield call(moreVehicleApi, payload);
    yield put({
      type: GET_MOREVEHICLE_SUCCESS,
      userMoreVehicle: userMoreVehicle,
    });
  } catch (e) {
    yield put({
      type: GET_MOREVEHICLE_FAILED,
      message: e.message
    })
    toast.error(e.message || 'Get More Vehicle Failed')
  }
}

export function* moreVehicleSaga() {
  yield takeEvery(GET_MOREVEHICLE_REQUESTED, fetchMoreVehicle);
}
